export default "__VITE_ASSET__BJvnrqVG__"